import { useState } from "react";

export function ActionSection({ id, service, status, setStatus }) {
    const [showModal, setShowModal] = useState(false);
    const [actionType, setActionType] = useState(""); // "resolved" ou "cancel"
    const [solutionApplied, setSolutionApplied] = useState("");
    const [avaliationResolution, setAvaliation] = useState(false);

    const openModal = (type) => {
        setActionType(type);
        setSolutionApplied(""); // limpa anterior
        setShowModal(true);
    };

    const handleSubmit = () => {
        const newStatus = actionType === "resolved" ? 3 : 4;

        service.updateCalledStatus(id, {
            solutionApplied,
            newStatus
        }).then(() => {
            setShowModal(false);
            setStatus(actionType === 3 ? 'RESOLVIDO' : 'CANCELADO')
        });
    };

    const avaliation = (value) => {
        service.updateFeedback(id, value).then(response => {
            setAvaliation(true);
        }).catch(error => console.error(error.response.data.message));
    }

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <i className="fas fa-cog mr-2 text-indigo-600"></i> Ações
            </h3>
            {status === "ABERTO" || status === "EXECUCAO" || status === "ESCALADO" ?
                <div className="space-y-3" >
                    <button
                        className="w-full flex items-center justify-between px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50"
                        onClick={() => openModal("resolved")}
                    >
                        <span className="text-gray-800">
                            <i className="fas fa-check-square mr-2 text-green-600"></i> Marcar como resolvido
                        </span>
                        <i className="fas fa-chevron-right text-gray-400"></i>
                    </button>
                    <button
                        className="w-full flex items-center justify-between px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50"
                        onClick={() => openModal("cancel")}
                    >
                        <span className="text-gray-800">
                            <i className="fas fa-check mr-2 text-red-400"></i> Cancelar chamado
                        </span>
                        <i className="fas fa-chevron-right text-gray-400"></i>
                    </button>
                </div>
                :
                <>
                    {avaliationResolution === false ?
                        <>
                            <p className="text-sm font-medium text-gray-800 ">
                                Avalie a resolução desse chamado na escala de 1 a 5
                            </p>
                            <div className="flex justify-content-between px-1 py-2">
                                <button className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700" onClick={() => avaliation(1)}>1</button>
                                <button className="px-4 py-2 bg-yellow-700 text-white rounded hover:bg-yellow-800" onClick={() => avaliation(2)} >2</button>
                                <button className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600" onClick={() => avaliation(3)}>3</button>
                                <button className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600" onClick={() => avaliation(4)}>4</button>
                                <button className="px-4 py-2 bg-green-700 text-white rounded hover:bg-green-800" onClick={() => avaliation(5)}>5</button>
                            </div>
                        </>
                        :
                        <>
                            <p className="text-sm font-medium text-gray-800">
                                Avaliação enviada com sucesso! Obrigado!
                            </p>
                        </>
                    }
                </>
            }
            {showModal && (
                <div className="fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                        <h2 className="text-lg font-semibold mb-4">
                            {actionType === "resolved" ? "Informe a resolução" : "Motivo do cancelamento"}
                        </h2>
                        <textarea
                            className="w-full border-1 border-gray-300 rounded-md p-2 mb-4"
                            rows={4}
                            placeholder={actionType === "resolved" ? "Descreva a solução aplicada..." : "Descreva o motivo do cancelamento..."}
                            value={solutionApplied}
                            onChange={(e) => setSolutionApplied(e.target.value)}
                        />
                        <div className="flex justify-end space-x-2">
                            <button
                                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                                onClick={() => setShowModal(false)}
                            >
                                Cancelar
                            </button>
                            <button
                                className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                                onClick={handleSubmit}
                                disabled={solutionApplied.trim() === ""}
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
